import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import WebFont from 'webfontloader';
import { createStore } from 'redux';
import 'babel-polyfill';
import './index.css';
import App from './app.component';
import portalApp from './reducers';
import registerServiceWorker from './registerServiceWorker';
import Interceptor from './services/Interceptors';
// import FirebaseService from './services/FirebaseService';
// import { initializeFirebase } from './push-notification';

WebFont.load({
  google: {
    families: ['Barlow:300,400,400i,500,600,700']
  }
});
const store = createStore(portalApp);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();
Interceptor.setupInterceptors();
// initializeFirebase();
// FirebaseService.setupFirebaseVapidKey();



// WEBPACK FOOTER //
// ./src/index.js